import React from 'react';
import { FormattedMessage } from 'react-intl';

const Cv = () => (
  <section id="cv" className="main">
    <h2>
      <a href="#cv">
        <i className="fa fa-graduation-cap" />
        <FormattedMessage id="cv" />
      </a>
    </h2>
    <h3><FormattedMessage id="curriculum.vitae" /></h3>
    <h4><FormattedMessage id="education" /></h4>
    <table>
      <tbody>
        <tr>
          <th>
            2015/04-
            <wbr />
            2020/03
          </th>
          <td><FormattedMessage id="affiliation.phd" /></td>
        </tr>
        <tr>
          <th>
            2011/04-
            <wbr />
            2015/03
          </th>
          <td><FormattedMessage id="affiliation.ba" /></td>
        </tr>
        <tr>
          <th>
            2008/04-
            <wbr />
            2011/03
          </th>
          <td><FormattedMessage id="affiliation.high" /></td>
        </tr>
      </tbody>
    </table>
    <h4><FormattedMessage id="employment" /></h4>
    <table>
      <tbody>
        <tr>
          <th>
            2024/04-
            <wbr />
            <FormattedMessage id="present" />
          </th>
          <td><FormattedMessage id="nvidia" /></td>
        </tr>
        <tr>
          <th>
            2020/04-
            <wbr />
            2024/03
          </th>
          <td><FormattedMessage id="ibm" /></td>
        </tr>
        <tr>
          <th>
            2018/04-
            <wbr />
            2020/03
          </th>
          <td><FormattedMessage id="jsps" /></td>
        </tr>
      </tbody>
    </table>
    <h3><FormattedMessage id="staff" /></h3>
    <ol reversed="reversed">
      <li>
        <a href="https://sigqs.ipsj.or.jp/committee.html" target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="ipsjqs" />
        </a>
      </li>
      <li>
        <a href="https://sites.google.com/site/qikansai/past/24meeting" target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="qikansai24" />
        </a>
          &nbsp;
        <FormattedMessage id="organizer" />
      </li>
      <li>
        <a href="https://cmpss.jp/forepast/ss2016/page/" target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="cmpss61" />
        </a>
          &nbsp;
        <FormattedMessage id="organizer" />
      </li>
      <li>
        <a href="https://sites.google.com/site/qikansai/" target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="qikansai" />
        </a>
          &nbsp;
        <FormattedMessage id="assistant.leader" />
      </li>
      <li>
        <a href="https://sites.google.com/site/qikansai/past/18meeting" target="_blank" rel="noreferrer noopener">
          <FormattedMessage id="qikansai18" />
        </a>
          &nbsp;
        <FormattedMessage id="organizer" />
      </li>
    </ol>
    <h3><FormattedMessage id="qualifications" /></h3>
    <ul className="fa-ul">
      <li><FormattedMessage id="ap" /></li>
    </ul>
    <h3><FormattedMessage id="award" /></h3>
    <ul className="fa-ul">
      <li><FormattedMessage id="goodspeaker" /></li>
    </ul>
  </section>
);

export default Cv;
